/**
 * Calculate brightness value by RGB or HEX color.
 * @param inputColor (String) The color value in RGB or HEX (for example: #000000 || #000 || rgb(0,0,0) || rgba(0,0,0,0))
 * @returns (Number) The brightness value (dark) 0 ... 255 (light)
 */
export function brightnessByColor (inputColor) {
    const c = getColorParts(inputColor);
    // sqrt( 0.299*R^2 + 0.587*G^2 + 0.114*B^2 )
    return c ? Math.floor(Math.sqrt((0.299 * (c.r ** 2)) + (0.750 * (c.g ** 2)) + (0.114 * (c.b ** 2)))) : null;
}

export function getColorParts(inputColor) {
    let color = String(inputColor);
    let isHEX = color.includes("#");
    let isRGB = color.includes("rgb");
    let r = undefined;
    let g = undefined;
    let b = undefined;
    if (isHEX) {
        const hasFullSpec = color.length === 7;
        const m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
        if (m) {
            r = parseInt(m[0] + (hasFullSpec ? '' : m[0]), 16);
            g = parseInt(m[1] + (hasFullSpec ? '' : m[1]), 16);
            b = parseInt(m[2] + (hasFullSpec ? '' : m[2]), 16);
        }
    }
    if (isRGB) {
        const m = color.match(/(\d+){3}/g);
        if (m) {
            r = m[0];
            g = m[1];
            b = m[2];
        }
    }
    return [r,g,b].some(i => i === undefined) ? null : {r,g,b};
}



// WEBPACK FOOTER //
// ./utilities/color.js